import { useEffect, useState, useCallback } from 'react';
import { Container, Image } from 'react-bootstrap';
import './Header.css';
import QRCode from 'react-qr-code';
import { Link, useLocation } from 'react-router-dom';
import { SignIn } from "./Signin";
import { Signout } from "./Signout";
import { useDispatch, useSelector } from 'react-redux'
import { authActions } from '_store'
import { resolveAvatarSrc } from 'utils/avatar';


const MENU_ITEMS = [
  { label: 'Home', href: '/' },
  { label: 'All Meetings', href: '/meetings' },

];

export default function Header() {

  const url = process.env.REACT_APP_URL;

  const dispatch = useDispatch()

  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [clubData, setClubData] = useState(null);
  const [search, setSearch] = useState('');
  const [nextMeeting, setNextMeeting] = useState(null)

  const { user: authUser } = useSelector(x => x.auth)
  const profile = authUser ? (authUser.user || authUser) : null;
  const avatar = resolveAvatarSrc(profile?.avatarUrl || profile?.avatar || '');

  const [club, setClub] = useState([])

  const fetchData = useCallback(async (endpoint, setData) => {
    try {
      const response = await fetch(`${url}/${endpoint}`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });
      if (response.ok) {
        const data = await response.json();
        setData(Array.isArray(data) ? data[0] : data);
      } else {
        console.error(`Error fetching ${endpoint}:`, response.statusText);
      }
    } catch (error) {
      console.error(`Error fetching ${endpoint}:`, error);
    }
  }, [url]);

  const getClubData = useCallback(() => fetchData("club", setClubData), [fetchData]);

  const signout = (e) => {
    e.preventDefault()
    dispatch(authActions.logout())
  }

  useEffect(() => {
    if (clubData) {
      setClub(clubData)
    }
  }, [clubData])

  useEffect(() => {
    getClubData()
  }, [getClubData])


  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 100);
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // No body scroll lock: allow page to scroll when menu is open

  const filteredItems = search
    ? (
      [
        ...MENU_ITEMS,
        ...(authUser ? [{ label: 'Users', href: '/users' }] : [])
      ].filter(item => item.label.toLowerCase().includes(search.toLowerCase()))
    )
    : [
      ...MENU_ITEMS,
      ...(authUser ? [{ label: 'Users', href: '/users' }] : [])
    ];

  const getNextMeeting = useCallback(async () => {
    try {
      const response = await fetch(`${url}/meetings/comingup`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })
      const data = await response.json()
      // console.log('Next meeting:', data)
      setNextMeeting(data)
    } catch (e) {
      console.log(`NavbarMenu - Next Meeting error: ${e}`)
    }
  }, [url])

  useEffect(() => {
    getNextMeeting()
  }, [getNextMeeting])

  // console.log(nextMeeting)

  return (
    <>
      <header className={`custom-header${scrolled ? ' scrolled' : ''}`}>
        <Container fluid className="header-container d-flex align-items-center justify-content-between">
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <button className="burger-menu" aria-label="Open menu" onClick={() => setMenuOpen(true)}>
              <span></span>
              <span></span>
              <span></span>
            </button>
            <span
              style={{
                color: '#fff',
                fontSize: '0.85rem',
                marginTop: '2px',
                letterSpacing: '0.1em',
                userSelect: 'none'
              }}
              onClick={() => setMenuOpen(true)}
              tabIndex={0}
              role="button"
              aria-label="Open menu"
            // onKeyPress={e => {
            //   if (e.key === 'Enter' || e.key === ' ') setMenuOpen(true);
            // }}
            >
              MENU
            </span>
          </div>
          <Link to="/" className="header-center text-center mx-auto" style={{ display: 'block', textDecoration: 'none', cursor: 'pointer', color: 'inherit', pointerEvents: 'auto' }}>
            <small className="club-type">{club.type}</small>
            <h4 className="club-name">{club.name}</h4>
          </Link>
          {!authUser ? <SignIn /> : <Signout />}
        </Container>
      </header>
      {menuOpen && (
        <div className="custom-menu-overlay" onClick={() => setMenuOpen(false)}>
          <nav
            className="custom-menu-panel"
            onClick={e => e.stopPropagation()}
          >
            {window.innerWidth < 769 ? (
              <div className="menu-header">
                <button className="close-menu" aria-label="Close menu" onClick={() => setMenuOpen(false)}>&times;</button>
                <div className="menu-header-center text-center mx-auto">
                  <Link to="/">
                    <small className="club-type">{club.type}</small>
                    <h4 className="club-name">{club.name}</h4>
                  </Link>
                </div>
                {/* <button className="sign-in-btn">{authUser ? 'Sign out' : 'Sign in'}</button> */}
                {authUser ?
                  <Link as={Link} to={`/profile/${profile?._id || ''}`} className='active navbar-link'>
                    <Image src={avatar} style={{ width: '70px', height: '70px' }} />
                  </Link>
                  :
                  <SignIn />
                }

              </div>
            ) : (
              <div className="menu-header-desktop">
                <button className="close-menu" aria-label="Close menu" onClick={() => setMenuOpen(false)}>&times;</button>
              </div>
            )}
            <div className="menu-items">
              {filteredItems.length === 0 ? (
                <div className="menu-item disabled">No results</div>
              ) : (
                <>
                  {/* Home always first */}
                  {filteredItems.filter(item => item.label === 'Home').map(item => {
                    const isActive = location.pathname === item.href || (item.href !== '/' && location.pathname.startsWith(item.href));
                    return (
                      <Link
                        key={item.label}
                        to={item.href}
                        className={`menu-item${isActive ? ' active' : ''}`}
                        onClick={() => setMenuOpen(false)}
                      >
                        {item.label}
                      </Link>
                    );
                  })}
                  {/* Next Meeting above All Meetings */}
                  {nextMeeting && nextMeeting._id && (
                    (() => {
                      let label = 'Next Meeting';
                      if (nextMeeting.meetingDate) {
                        const today = new Date();
                        // Parse dd/MM/yyyy
                        const [day, month, year] = nextMeeting.meetingDate.split('/').map(Number);
                        const meetingDate = new Date(year, month - 1, day);
                        // Compare only the date part (year, month, day)
                        // console.log(meetingDate)
                        if (
                          today.getFullYear() === meetingDate.getFullYear() &&
                          today.getMonth() === meetingDate.getMonth() &&
                          today.getDate() === meetingDate.getDate()
                        ) {
                          label = "Today's meeting";
                        }
                      }
                      return (
                        <Link
                          key="next-meeting"
                          to={`/meeting/${nextMeeting._id}`}
                          className={`menu-item${location.pathname === `/meeting/${nextMeeting._id}` ? ' active' : ''}`}
                          onClick={() => setMenuOpen(false)}
                        >
                          {label}
                        </Link>
                      );
                    })()
                  )}
                  {/* All Meetings and the rest */}
                  {filteredItems.filter(item => item.label !== 'Home').map(item => {
                    const isActive = location.pathname === item.href || (item.href !== '/' && location.pathname.startsWith(item.href));
                    return (
                      <Link
                        key={item.label}
                        to={item.href}
                        className={`menu-item${isActive ? ' active' : ''}`}
                        onClick={() => setMenuOpen(false)}
                      >
                        {item.label}
                      </Link>
                    );
                  })}
                </>
              )}
            </div>
            <div className="menu-qr" style={{ display: 'flex', justifyContent: 'center', margin: '1.5rem 0 0.5rem 0' }}>
              <QRCode
                title="QR Code"
                value={window.location.href}
                size={150}
                bgColor="#181b23"
                fgColor="#fff"
              />
            </div>
            <div className="menu-qr-text" style={{ display: 'flex', justifyContent: 'center', marginBottom: '.3rem', color: '#555' }}>
              <p className='text-center'>Share this page via QR code</p>
            </div>
            <div className="menu-search">
              <input
                type="text"
                placeholder="Search or jump to..."
                value={search}
                onChange={e => setSearch(e.target.value)}
              />
            </div>
            {authUser &&
              <Link onClick={signout} className='menu-signout-btn'>Sign out</Link>
            }
          </nav>
        </div>
      )}
    </>
  );
}
